import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './TargetDateSeriesAllNamesTickers.css'

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesAllNamesTickers extends Component {
  static propTypes = {
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)
  }

  render() {
    const { targetDateSeries } = this.props

    return (
      <div>
        <div>
          <p styleName='all-list-headline'>All funds in this target date series</p>
          <p styleName='all-list-copy'>
            A <b>target date fund series</b> consist of around 10 or 12
            different funds, each with their own "target date" marketed at
            different age demographics. We use the 2050 fund to assign ratings
            to target date fund series - this is the fund that would be
            marketed to savers looking to retire around the year 2050. As time
            progresses and this "target date" approaches, the portfolio mix of
            the fund shifts away from stocks and towards bonds and other
            less-risky investments. Usually, the mix of stocks in the
            portfolio stays the same across a target date fund series, meaning
            if you are invested in a fund from this target date series that is
              dated closer to today than 2050, you're likely invested in the
            same companies flagged above, but you may have lower levels of
            exposure. We currently only have detailed results for the 2050
            version of this target date fund series.
          </p>
          <div styleName='all-tickers-flex'>
            {
              targetDateSeries.strategy_fund_legal_names.split(', ').map(
                (e, i) => {
                  return (
                    <div key={'tds-sfln-'+i} styleName='all-tickers-item'>
                      { e }
                    </div>
                  )
                }
              )
            }
          </div>
        </div>
        { targetDateSeries.strategy_tickers && targetDateSeries.strategy_tickers.length > 0 ?
          <div>
            <p styleName='all-list-headline'>
              All tickers for this target date series
            </p>
            <p styleName='all-list-copy'>
              Tickers for each shareclass available
              from every fund in this target date series.
            </p>
            <div styleName='all-tickers-flex'>
              {
                targetDateSeries.strategy_tickers.split(', ').map((e, i) => {
                  return (
                    <div key={'tds-tcks-'+i} styleName='all-tickers-item'>
                      { e }
                    </div>
                  )
                })
              }
            </div>
          </div> :
          null
        }
      </div>
    )
  }
}